import type { FetchContext } from 'ofetch'
import type { IdentityGenerationOutcome } from '~/types/IdentityGenerationOutcome'

// Bumped by every account-scoped reset, so a response captured under an older value belongs to an identity that has since been cleared.
class IdentityGeneration {
  #generation = 0
  #rejectedRequests = new WeakSet<FetchContext>()

  recordRejectedCredential(context: FetchContext): void {
    this.#rejectedRequests.add(context)
  }

  hasRejectedCredential(context: FetchContext): boolean {
    return this.#rejectedRequests.has(context)
  }

  bump(): void {
    this.#generation += 1
  }

  current(): number {
    return this.#generation
  }

  isCurrent(generation: number): boolean {
    return generation === this.#generation
  }

  async resolveFor<T>(
    operation: () => Promise<T>,
    generation: number = this.#generation
  ): Promise<IdentityGenerationOutcome<T>> {
    const value = await operation()
    return { status: this.isCurrent(generation) ? 'current' : 'superseded', value }
  }
}

export const identityGeneration = new IdentityGeneration()
